import { PageMeta } from '@components/page-meta';
import PageContainer from '@components/PageContainer';
import { RouteComponentProps } from '@reach/router';
import TermsAndConditionsForm from 'src/containers/TermsAndConditionsForm';

const TermsAndConditionsPage = (_props: RouteComponentProps) => (
  <>
    <PageMeta title="termsAndConditions.termsAndConditions" />
    <PageContainer>
      <TermsAndConditionsForm />
    </PageContainer>
  </>
);

export default TermsAndConditionsPage;
